export default class RouteFeatureData {
    constructor(emissions, consumption, expenses, savings, distance, fuelLowSulfur, fuelOil, tce, time) {
        this.emissions = emissions,
            this.consumption = consumption,
            this.expenses = expenses,
            this.savings = savings,
            this.distance = distance,
            this.fuelLowSulfur = fuelLowSulfur,
            this.fuelOil = fuelOil,
            this.tce = tce,
            this.time = time
    }

    get totalFuel() {
        return this.fuelLowSulfur + this.fuelOil
    }



}